import React, { useState, useCallback, useRef, useEffect } from "react";
import "../Home/Home.css";
import { HiOutlineArrowLongUp } from "react-icons/hi2";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import format from "date-fns/format";
import { addDays } from "date-fns";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const handleFloatingAction = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  const [visibleDescriptions, setVisibleDescriptions] = useState([
    false,
    false,
    false,
  ]);

  const toggleDescription = (index) => {
    setVisibleDescriptions((prevState) => {
      const newVisibility = [...prevState];
      newVisibility[index] = !newVisibility[index];
      return newVisibility;
    });
  };

  const services = ["PROPERTY MANAGEMENT", "CONCIERGE SERVICES"];
  const descriptions = [
    "Trust us with your wide range of properties, where we ensure smooth operation, maintenance and profitability of your real estate assets.",
    "We care to take every minute detail throughout our resident’s stay, our responsibility - making sure our concierge services allows you to entirely enjoy your stay.",
  ];

  const [Calendar, setCalendar] = useState(false);

  const openForm_Calendar = () => {
    setCalendar(true);
  };

  const closeForm_Calendar = () => {
    setCalendar(false);
  };

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection",
    },
  ]);

  const handleDateChange = (item) => {
    try {
      const startDate = new Date(item.selection.startDate);
      const endDate = new Date(item.selection.endDate);

      // Normalize the dates by setting the time to midnight
      startDate.setHours(12, 0, 0, 0);
      endDate.setHours(12, 0, 0, 0);

      setRange([
        {
          startDate: startDate,
          endDate: endDate,
          key: "selection",
        },
      ]);
    } catch (error) {
      console.error("Error while setting date range: ", error);
    }
  };

  const [setOpen] = useState(false);

  const refOne = useRef(null);

  const hideOnEscape = useCallback(
    (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    },
    [setOpen]
  );

  const hideOnClickOutside = useCallback(
    (e) => {
      if (refOne.current && !refOne.current.contains(e.target)) {
        setOpen(false);
      }
    },
    [setOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, [hideOnClickOutside, hideOnEscape]);

  const handleBookVilla = useCallback(() => {
    navigate("/BookVilla", {
      state: {
        startDate: range[0].startDate,
        endDate: range[0].endDate,
      },
    });
  }, [navigate, range]);

  const checkInBoxRef = useRef(null);
  const hrLineRef = useRef(null);
  const [isStopped, setIsStopped] = useState(false);

  useEffect(() => {
    const target = hrLineRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsStopped(true); // hr is visible → stop the box
        } else {
          setIsStopped(false); // hr not visible → keep it fixed
        }
      },
      {
        root: null,
        threshold: 0,
      }
    );

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target); // safe cleanup
      }
    };
  }, []);

  return (
    <div>
      <div className="bg-[#FAFAFA] text-[14px] md:text-xl lg:text-[16px] 2xl:text-2xl leading-7 md:leading-8 lg:leading-7 2xl:leading-10">
        {/* Section 1 starts */}
        <div className="footer_bgImg_m lg:hidden">
          <div className="flex flex-col items-center text-white py-[20%]">
            <p className="mx-[8%] my-[10%] text-center">
              Don’t hesitate with your questions, our Villa Advisor is here,
              solely for your curiosity.
            </p>
            <a
              href="https://wa.me/+918866262368?text=Hello%2C%20Soham%20Villas%20Team%21%0A%0AI%E2%80%99m%20excited%20to%20inquire%20about%20a%20stay%20with%20you%21%20Here%20are%20the%20details%20I%E2%80%99d%20like%20to%20share%3A%0A%0A-%20Check-in%20Date%3A%20%5BYour%20check-in%20date%5D%0A-%20Check-out%20Date%3A%20%5BYour%20check-out%20date%5D%0A-%20Number%20of%20Guests%3A%20%5BTotal%20number%20of%20guests%5D%0A-%20Approx.%20Budget%3A%20%5BYour%20budget%20range%5D%0A-%20Preferred%20Property%3A%20%5BName%20of%20the%20property%20you%E2%80%99re%20interested%20in%5D%0A-%20Special%20Requests%3A%20%5BAny%20specific%20needs%20or%20wishes%5D%0A%0AI%20can%E2%80%99t%20wait%20to%20hear%20from%20you%20and%20plan%20a%20memorable%20experience%20together%21%0A%0AThank%20you%20so%20much%21%20%F0%9F%98%8A"
              target="_blank"
              rel="noreferrer"
              className="border rounded-full px-[1%] hover:scale-110 transition-transform duration-300 ease-in-out"
            >
              TALK TO OUR VILLA ADVISOR
            </a>
          </div>
        </div>
        <div className="footer_bgImg hidden lg:block">
          <div className="flex flex-col items-center text-white py-[6%]">
            <p className="mx-[30%] my-[5%] text-xl 2xl:text-3xl text-center">
              Don’t hesitate with your questions, our Villa Advisor is here,
              solely for your curiosity
            </p>
            <a
              href="https://wa.me/+918866262368?text=Hello%2C%20Soham%20Villas%20Team%21%0A%0AI%E2%80%99m%20excited%20to%20inquire%20about%20a%20stay%20with%20you%21%20Here%20are%20the%20details%20I%E2%80%99d%20like%20to%20share%3A%0A%0A-%20Check-in%20Date%3A%20%5BYour%20check-in%20date%5D%0A-%20Check-out%20Date%3A%20%5BYour%20check-out%20date%5D%0A-%20Number%20of%20Guests%3A%20%5BTotal%20number%20of%20guests%5D%0A-%20Approx.%20Budget%3A%20%5BYour%20budget%20range%5D%0A-%20Preferred%20Property%3A%20%5BName%20of%20the%20property%20you%E2%80%99re%20interested%20in%5D%0A-%20Special%20Requests%3A%20%5BAny%20specific%20needs%20or%20wishes%5D%0A%0AI%20can%E2%80%99t%20wait%20to%20hear%20from%20you%20and%20plan%20a%20memorable%20experience%20together%21%0A%0AThank%20you%20so%20much%21%20%F0%9F%98%8A"
              target="_blank"
              rel="noreferrer"
              className="border rounded-full px-[1%] hover:scale-110 transition-transform duration-300 ease-in-out"
            >
              TALK TO OUR VILLA ADVISOR
            </a>
          </div>
        </div>
        {/* Section 1 ends */}

        {/* Section 2 starts */}
        <div className="my-[5%] md:my-[3%]">
          <p
            className="title text-[#877D6F] text-center text-xl md:text-3xl 2xl:text-4xl"
            style={{ letterSpacing: "2px" }}
          >
            OUR SERVICES
          </p>
          <div className="mx-[4%] md:mx-[15%]">
            {services.map((service, index) => (
              <div key={index} className="flex flex-col items-start my-[3%]">
                <div className="flex items-center justify-between w-full">
                  <p
                    className="title text-lg md:text-2xl 2xl:text-3xl"
                    style={{ letterSpacing: "3px" }}
                  >
                    {`0${index + 1}   ${service}`}
                  </p>
                  {service === "CONSTRUCTION" ? (
                    <button
                      onClick={() => toggleDescription(index)}
                      className="hover:underline"
                      name="readMore_btn"
                    >
                      Read more
                    </button>
                  ) : (
                    <a
                      href={
                        service === "PROPERTY MANAGEMENT"
                          ? "/PropertyManagement"
                          : "/ConciergeServices"
                      }
                      className="hover:underline"
                    >
                      Read more
                    </a>
                  )}
                </div>
                {service === "CONSTRUCTION" && visibleDescriptions[index] && (
                  <p className="mt-2 text-gray-600">{descriptions[index]}</p>
                )}
              </div>
            ))}
          </div>

          <a
            href="https://www.airbnb.co.in/users/show/6284962"
            className="grid grid-cols-1 md:grid-cols-2 place-items-center mt-[8%] md:mt-[3%] lg:mt-0"
            target="_blank"
            rel="noreferrer"
          >
            <div className="px-[5%] md:pl-[5%] md:pr-0 lg:pl-[20%]">
              <img
                className="skeleton rounded-xl"
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/282413a6-8afc-4c52-a015-edbe0b563100/public"
                alt="Room-Img"
              />{" "}
              {/* footer_img.webp */}
            </div>
            <div className="mt-[5%] md:mt-0 text-center">
              <p
                className="heading_light"
                style={{ letterSpacing: "4px", wordSpacing: "4px" }}
              >
                OUR TRUSTED BOOKING PARTNER
              </p>
              <p className="title text-2xl md:text-4xl 2xl:text-5xl my-[3%]">
                AIRBNB
              </p>
              <div className="flex justify-center">
                {Array(5)
                  .fill("")
                  .map((_, idx) => (
                    <div
                      key={idx}
                      className="h-1.5 w-1.5 2xl:h-2 2xl:w-2 rounded-full mx-[1%] md:mx-[2%] bg-[#877D6F]"
                    ></div>
                  ))}
              </div>
              <p className="heading mt-[6%]" style={{ letterSpacing: "3px" }}>
                4.9/5 SUPERHOST
              </p>
            </div>
          </a>
        </div>
        {/* Section 2 ends */}

        {/* Section 3 starts */}
        <div className="bg-[#877D6F] text-white px-[5%] pt-[8%] lg:pt-[5%] pb-[3%] relative">
          <div className="flex flex-col lg:flex-row">
            <button
              className="absolute right-5 lg:right-[3%] 2xl:right-[5%]"
              onClick={scrollToTop}
              name="scrollToTop_btn"
            >
              <HiOutlineArrowLongUp className="border rounded-full h-10 w-10 lg:h-12 lg:w-12 2xl:h-14 2xl:w-14 p-1 hover:bg-white hover:text-[#877D6F]" />
            </button>
            <div className="mx-[2%] lg:w-[30%] mb-[5%]">
              <img
                className="h-8 md:h-10 2xl:h-14"
                src="../assets/white_soham_logo.webp"
                alt="SohamVillas-Logo"
              />{" "}
              {/* white_soham_logo.webp */}
              <p className="w-[80%] my-[6%] leading-5 2xl:leading-7">
                We make the world of luxury, meet the comfort of home, with our
                crafted collection of villas and apartments.
              </p>
              <div className="flex items-center gap-1">
                <AiFillInstagram className="text-lg" />
                <a
                  href="https://www.instagram.com/sohamvillas"
                  target="_blank"
                  rel="noreferrer"
                  className="heading_light my-[1%] hover:underline"
                  style={{ letterSpacing: "1px" }}
                >
                  INSTAGRAM
                </a>
              </div>
              <div className="flex items-center gap-1">
                <FaFacebookSquare />
                <a
                  href="https://www.facebook.com/sohamvillas"
                  target="_blank"
                  rel="noreferrer"
                  className="heading_light my-[1%] hover:underline"
                  style={{ letterSpacing: "1px" }}
                >
                  FACEBOOK
                </a>
              </div>
            </div>
            <div className="flex flex-col mx-[2%] lg:w-[25%] mb-[5%]">
              <p
                className="heading underline text-xl md:text-2xl 2xl:text-4xl mb-[5%] lg:mb-[10%]"
                style={{ letterSpacing: "4px" }}
              >
                QUICK LINKS
              </p>
              <a href="/BookVilla" className="hover:underline">
                VILLAS
              </a>
              <a href="/Apartments" className="hover:underline">
                APARTMENTS
              </a>
              <a href="/Blogs" className="hover:underline">
                BLOGS
              </a>
              <a href="/Experiences" className="hover:underline">
                EXPERIENCES
              </a>
            </div>
            <div className="flex flex-col mx-[2%] lg:w-[47%] mb-[5%]">
              <p
                className="heading underline text-xl md:text-2xl 2xl:text-4xl mb-[5%] lg:mb-[6%]"
                style={{ letterSpacing: "4px" }}
              >
                CONTACT & RESERVATIONS
              </p>
              <a href="/" className="mb-[5%] hover:underline">
                HELLO@SOHAMVILLAS.COM
              </a>
              {["+917767047535", "+918866262368", "+919510598157"].map(
                (contact, idx) => (
                  <a
                    key={idx}
                    href={`tel:${contact}`}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                  >
                    {contact}
                  </a>
                )
              )}
            </div>
          </div>

          <div
            ref={checkInBoxRef}
            className={`${
              isStopped
                ? "absolute bottom-20 2xl:bottom-32"
                : "fixed bottom-3.5"
            } left-4 lg:left-1/2 lg:-translate-x-1/2 right-4 lg:w-[70%] 2xl:w-[55%] border border-gray-200 bg-gray-200/60 backdrop-blur-lg py-2.5 px-4 shadow-md flex flex-col sm:flex-row items-start sm:items-end gap-4 z-30 text-sm rounded-xl md:rounded-full transition-all duration-500`}
          >
            <div className="flex flex-col md:flex-row gap-2 items-center mx-auto md:ml-5">
              <div className="flex-1 sm:w-[520px] 2xl:w-[580px]">
                <button
                  className="flex flex-col md:flex-row gap-1 items-center text-center text-sm 2xl:text-lg leading-6"
                  onClick={openForm_Calendar}
                  name="checkIn_checkOut_btn"
                >
                  <label className="text-black text-xs sm:text-sm 2xl:text-lg">
                    Check - In & Check - Out:&nbsp;&nbsp;
                  </label>
                  <div className="bg-white text-black text-xs sm:text-sm px-4 py-1.5 rounded-full">
                    {`${range[0].startDate.toLocaleDateString()} - ${range[0].endDate.toLocaleDateString()}`}
                  </div>
                </button>
              </div>

              <button
                className="flex-1 w-full max-w-60 md:max-w-40 lg:max-w-60 sm:-ml-72 md:-ml-24 lg:ml-0 bg-[#877d6f] text-white rounded-full px-2 py-1.5 text-[12px] md:text-sm 2xl:text-lg leading-4 hover:border-[1px] hover:border-[#333333] hover:bg-white hover:text-[#333333]"
                onClick={handleBookVilla}
                name="reserveNow_btn"
                itemProp="offers"
              >
                BOOK&nbsp;NOW
              </button>
            </div>

            <div className="w-full">
              <div
                className={`fab ${isOpen ? "open" : ""}`}
                onClick={handleFloatingAction}
              >
                <span
                  className={`fab ${
                    isOpen ? "rotate_floatingAction_btn" : "floatingAction_btn"
                  }`}
                >
                  +
                </span>
                <div className="fab-menu">
                  <a
                    href="https://www.instagram.com/sohamvillas/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="bg-white border-2 rounded-full h-[1.8em] w-[1.8em]"
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5ca08b60-f697-47b7-27aa-88265db53400/public"
                      alt="Instagram-Icon"
                    />{" "}
                    {/* Instagram_icon_soham.webp */}
                  </a>

                  <a
                    href="https://wa.me/+918866262368?text=Hello%2C%20Soham%20Villas%20Team%21%0A%0AI%E2%80%99m%20excited%20to%20inquire%20about%20a%20stay%20with%20you%21%20Here%20are%20the%20details%20I%E2%80%99d%20like%20to%20share%3A%0A%0A-%20Check-in%20Date%3A%20%5BYour%20check-in%20date%5D%0A-%20Check-out%20Date%3A%20%5BYour%20check-out%20date%5D%0A-%20Number%20of%20Guests%3A%20%5BTotal%20number%20of%20guests%5D%0A-%20Approx.%20Budget%3A%20%5BYour%20budget%20range%5D%0A-%20Preferred%20Property%3A%20%5BName%20of%20the%20property%20you%E2%80%99re%20interested%20in%5D%0A-%20Special%20Requests%3A%20%5BAny%20specific%20needs%20or%20wishes%5D%0A%0AI%20can%E2%80%99t%20wait%20to%20hear%20from%20you%20and%20plan%20a%20memorable%20experience%20together%21%0A%0AThank%20you%20so%20much%21%20%F0%9F%98%8A"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="bg-white border-2 rounded-full h-[1.8em] w-[1.8em]"
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5584a9c6-9f95-463c-54eb-32fd89e84800/public"
                      alt="Whatsapp-Icon"
                    />{" "}
                    {/* whatsapp_icon_soham.webp */}
                  </a>

                  <a href="tel:+918866262368" target="_blank" rel="noreferrer">
                    <img
                      className="bg-white border-2 rounded-full h-[1.8em] w-[1.8em]"
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5c2c284d-7eb2-4bc9-77f9-01ee38cbf400/public"
                      alt="Call-Icon"
                    />{" "}
                    {/* call_icon_soham.webp */}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <hr ref={hrLineRef} />

          <div className="flex flex-col lg:flex-row justify-between">
            <div className="flex gap-10">
              {["TERMS", "REFUND POLICY", "PRIVACY POLICY"].map(
                (policy, idx) => (
                  <a
                    key={idx}
                    href={`/${policy.replace(" ", "")}`}
                    className="heading_light hover:scale-105"
                    style={{ letterSpacing: "1px" }}
                  >
                    {policy}
                  </a>
                )
              )}
            </div>
            <a
              href="https://inittechnology.co"
              className="heading_light text-white hover:underline mt-[5%] lg:mt-0"
              target="_blank"
              rel="noreferrer"
              style={{ letterSpacing: "1px", fontSize: "12px" }}
            >
              ALL RIGHTS RESERVED BY BE AT EASE PVT LTD | COPYRIGHTS © INIT
              TECHNOLOGY{" "}
            </a>
          </div>
        </div>
        {/* Section 3 ends */}

        {Calendar && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-50"
              onClick={closeForm_Calendar}
            ></div>

            <div className="fixed mt-10 top-1/2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-2xl p-3">
              <div className="flex justify-between items-center mb-4">
                <p className="text-lg font-semibold">CALENDAR</p>
                <button
                  onClick={closeForm_Calendar}
                  className="text-gray-500 text-xl font-bold hover:text-black"
                >
                  &times;
                </button>
              </div>

              <div className="calendarWrap border border-gray-300 rounded-lg overflow-hidden">
                <input
                  value={`${format(
                    range[0].startDate,
                    "dd/MM/yyyy"
                  )} - ${format(range[0].endDate, "dd/MM/yyyy")}`}
                  readOnly
                  className="bg-gray-100 text-center w-full py-2 px-3 font-medium outline-none"
                  onClick={() => setOpen((open) => !open)}
                />

                <div className="custom-calendar bg-white">
                  <DateRange
                    onChange={handleDateChange}
                    editableDateInputs={true}
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    rangeColors={["#877D6F"]}
                    months={1}
                    direction="horizontal"
                    minDate={new Date()}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
